<template>
  <DomainVerificationPermissionRulesTable />
</template>

<script setup lang="ts">
import DomainVerificationPermissionRulesTable from '@/components/deepadmin/domain-verifications/DomainVerificationPermissionRulesTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey:
      'navigation.organization.settings.security.domain_verifications.group_mappings',
  },
})
</script>
